import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "followers-by-gender-card card mb-4 border-0 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-header d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "trezo-card-subtitle" }
const _hoisted_5 = { class: "trezo-card-header-menu position-relative" }
const _hoisted_6 = { class: "dropdown action-opt" }
const _hoisted_7 = { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }
const _hoisted_8 = { class: "trezo-card-content" }
const _hoisted_9 = { class: "chart" }
const _hoisted_10 = { class: "bottom-info d-flex align-items-center justify-content-between" }
const _hoisted_11 = { class: "item d-flex" }
const _hoisted_12 = { class: "d-block fw-medium text-black" }
const _hoisted_13 = { class: "item d-flex" }
const _hoisted_14 = { class: "d-block fw-medium text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "trezo-card-title" }, [
          _createElementVNode("h5", { class: "mb-0 fw-semibold" }, "Followers by Gender"),
          _createElementVNode("p", { class: "fw-normal" }, "Understand your audience better!")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("button", {
                class: "btn bg-transparent p-0",
                type: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false"
              }, [
                _createElementVNode("i", { class: "ri-more-2-fill" })
              ], -1)),
              _createElementVNode("ul", _hoisted_7, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateTimeframe('day')))
                  }, " This Day ")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateTimeframe('week')))
                  }, " This Week ")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateTimeframe('month')))
                  }, " This Month ")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateTimeframe('year')))
                  }, " This Year ")
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "info text-center" }, [
          _createElementVNode("span", { class: "d-block fw-medium text-black" }, " 54,500 "),
          _createElementVNode("span", { class: "d-block text-xs" }, " Total Followers ")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "pie",
                height: "201",
                options: _ctx.followersByGender,
                series: _ctx.gender
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dot bg-primary rounded-circle" }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.malePercentage) + "% ", 1),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "b-block mt-0 mb-0 text-xs" }, " Male Followers ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dot bg-purple rounded-circle" }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.femalePercentage) + "% ", 1),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "b-block mt-0 mb-0 text-xs" }, " Female Followers ", -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}